import Image1 from "./Dummy-Images/1.png"
import Image2 from "./Dummy-Images/2.png"
import Image3 from "./Dummy-Images/3.png"
import Image4 from "./Dummy-Images/4.png"
import Image5 from "./Dummy-Images/5.png"
import Image6 from "./Dummy-Images/6.png"
import Image7 from "./Dummy-Images/7.png"
import Image8 from "./Dummy-Images/8.png"
import Image9 from "./Dummy-Images/9.png"
import Image10 from "./Dummy-Images/10.png"
import Image11 from "./Dummy-Images/11.png"
import Image12 from "./Dummy-Images/12.jpg"
import Image13 from "./Dummy-Images/13.png"
import Image14 from "./Dummy-Images/14.png"
import Image15 from "./Dummy-Images/15.png"
import Image16 from "./Dummy-Images/16.png"
import Image17 from "./Dummy-Images/17.png"
import Image18 from "./Dummy-Images/18.png"
import Image19 from "./Dummy-Images/19.png"
import Image20 from "./Dummy-Images/20.png"
import Image21 from "./Dummy-Images/21.png"
import Image22 from "./Dummy-Images/22.jpg"
import Image23 from "./Dummy-Images/23.png"
import Image24 from "./Dummy-Images/24.png"
import Image25 from "./Dummy-Images/25.png"
import Image26 from "./Dummy-Images/26.png"
import Image27 from "./Dummy-Images/27.png"
import Image28 from "./Dummy-Images/28.png"
import Image29 from "./Dummy-Images/29.png"
import Image30 from "./Dummy-Images/30.png"
const Dummy = {
    data :
    [
        {
            id:'1',
            category : 'Fabrics',
            image : Image1,
            name : 'Jeans Patched Fabric',
            price : 40000,
            description : 'Surplus fabric collected from fashion production that is no longer needed by the factory that are patched into certain sizes. Size : 1 x 2 meter.'
        },
        {
            id:'2',
            category : 'Fabrics',
            image : Image2,
            name : 'Cotton Fabric',
            price : 55000,
            description : 'Residue cotton fabrics from the production of cotton-based wears. Size : 1 x 2 meter.'
        },
        {
            id:'3',
            category : 'Fabrics',
            image : Image3,
            name : 'Unprocessed Denim Fabric',
            price : 75000,
            description : 'Denim fabric that are leftover, not been processed after the first use. Size : 1 x 2 meter.'
        },
        {
            id:'4',
            category : 'Fabrics',
            image : Image4,
            name : 'Alternating Design Patched Fabric',
            price : 60000,
            description : 'Leftover fabrics from fashion productions that has been processed into an alternating design fabric. Size : 1 x 2 meter.'
        },
        {
            id:'5',
            category : 'Fabrics',
            image : Image5,
            name : 'Cotton Doubl Layer Knitted Fabric',
            price : 60000,
            description : 'Leftover fabric knitted to sized fabric in a double-layered style. Size : 1 x 2 meter.'
        },
        {
            id: '6',
            category : 'Fabrics',
            image : Image6,
            name : 'Fixed Sized Denim Fabric',
            price : 12000,
            description : 'Denim fabric residue left from wear production, in fixed sizes. Size : 1 x 2 meter.'
        },
        {
            id:'7',
            category : 'Fabrics',
            image : Image7,
            name : 'Polyester Fabric',
            price : 90000,
            description :'Fabric leftover from the production of a European bag manufacturer. Size : 1 x 2 meter.'
        },
        {
            id: '8',
            category : 'Fabrics',
            image : Image8,
            name : 'Patched Fabric Scraps',
            price : 30000,
            description : 'Fabric scraps patched into certain sizes made for upcycling. Size : 1 x 2 meter.'
        },
        {
            id:'9',
            category : 'Fabrics',
            image : Image9,
            name : 'Nylon Fabric',
            price : 110000,
            description : 'Nylon fabric residue left from the production from a wear manufacturer. Size : 1 x 2 meter.'
        },
        {
            id:'10',
            category : 'Fabrics',
            image : Image10,
            name : 'Linen Cotton Cuts',
            price : 45000,
            description : 'Leftover fabric linen cotton cuts. Size : 1 x 2 meter.'
        },
        {
            id: '11',
            category : 'Zero-Waste Fashion',
            image : Image11,
            name : "Foldable Bag The Daily Habit",
            price : 110000,
            description : "Totebag with an esthetic modify unisex."
        },
        {
            id: '12',
            category : 'Zero-Waste Fashion',
            image : Image12,
            name : "Unisex Fisherman Knit Sweater - Red Threads",
            price : 250000,
            description : "Pushing the frontiers of sustainable fashion through the use of reclaimed materials in making one-of-a-kind clothes for women."
        },
        {
            id: '13',
            category : 'Zero-Waste Fashion',
            image : Image13,
            name : "Beachside Bundle",
            price : 200000,
            description : "casual wear using deadstock materials for women."
        },
        {
            id: '14',
            category : 'Zero-Waste Fashion',
            image : Image14,
            name : "Jacket for Women",
            price : 300000,
            description : "clothing mostly from recycled materials for women."
        },
        {
            id: '15',
            category : 'Zero-Waste Fashion',
            image : Image15,
            name : "Recycled Vintage Painted Jacket Check",
            price : 250000,
            description : "from production waste and offcuts to create stunning pieces unisex."
        },
        {
            id: '16',
            category : 'Zero-Waste Fashion',
            image : Image16,
            name : "Zip Front PVC Leather Jacket",
            price : 200000,
            description : "Retro produces upcycled clothing under its reworked sub brand crafted from secondhand recycled items unisex."
        },
        {
            id: '17',
            category : 'Zero-Waste Fashion',
            image : Image17,
            name : "Remnants Marled Baby Tee",
            price : 150000,
            description : "Sustainable fashion through various sustainability initiatives unisex."
        },
        {
            id: '18',
            category : 'Zero-Waste Fashion',
            image : Image18,
            name : "Daybreak Sweetshirt",
            price : 300000,
            description : "Upcycling clothing and zero waste fashion unisex."
        },
        {
            id: '19',
            category : 'Zero-Waste Fashion',
            image : Image19,
            name : "High Rise Loose",
            price : 400000,
            description : "upcycled denim clothing for women."
        },
        {
            id: '20',
            category : 'Zero-Waste Fashion',
            image : Image20,
            name : "Seventyseven Cord Utility Shorts",
            price : 150000,
            description : "sustainable materialsf for men."
        },
        {
            id: '21',
            category : 'Thrift',
            image : Image21,
            name : "Dress Pants",
            price : 70000,
            description : "Brown cotton-based dress pants for women."
        },
        {
            id: '22',
            category : 'Thrift',
            image : Image22,
            name : "Old Blue Shorts",
            price : 70000,
            description : "Blue nylon-based shorts for women"
        },
        {
            id: '23',
            category : 'Thrift',
            image : Image23,
            name : "Rustler Jeans",
            price : 70000,
            description : "Navy blue cotton-based jeans for men"
        },
        {
            id: '24',
            category : 'Thrift',
            image : Image24,
            name : "Mitre Shorts",
            price : 70000,
            description : "Black cotton-based shorts for men."
        },
        {
            id: '25',
            category : 'Thrift',
            image : Image25,
            name : "Charlotte Russe Dress",
            price : 100000,
            description : "Pink rayon-based dress"
        },
        {
            id: '26',
            category : 'Thrift',
            image : Image26,
            name : "PrettyLittleThing Jumpsuit",
            price : 100000,
            description : "Black elastane-based jumpsuit"
        },
        {
            id: '27',
            category : 'Thrift',
            image : Image27,
            name : "No Boundaries Legging",
            price : 50000,
            description : "Cotton based legging for girls"
        },
        {
            id: '28',
            category : 'Thrift',
            image : Image28,
            name : "Old Navy Sweater",
            price : 90000,
            description : "Navy cotton-based sweater for boys"
        },
        {
            id: '29',
            category : 'Thrift',
            image : Image29,
            name : "Old Navy Vest",
            price : 110000,
            description : "Black polyster-based vest for men"
        },
        {
            id: '30',
            category : 'Thrift',
            image : Image30,
            name : "Axist Shirt",
            price : 90000,
            description : "Black button-down long sleeve cotton shirt for men"
        }
    ]   
}

export default Dummy;
